<template>
    <div>
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <ck-editor-form-group
                v-model="data.content"
                name="content"
                label="Content"
                :error="(errors.content || [])[0]"
        />

        <select-form-group
                v-model="data.image_position"
                name="image_position"
                label="Image Position"
                :error="(errors.image_position || [])[0]"
                :nullable="true"
                :options="[{value: 'right', label: 'Right'}, {value: 'left', label: 'Left'}]"
        />

        <gallery-form-group
                v-model="data.image_id"
                name="image_id"
                label="Image"
                :error="(errors.image_id || [])[0]"
                :nullable="true"
        />

        <text-form-group
                v-model="data.anchor"
                name="anchor"
                label="Anchor"
                :error="(errors.anchor || [])[0]"
        />

    </div>
</template>

<script>
    import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
    import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {CkEditorFormGroup, GalleryFormGroup, SelectFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
